module.exports = __webpack_public_path__ + "static/media/smallLogoColor.f02a05bc.svg";